import PropTypes from 'prop-types';

export default PropTypes.shape({
  key: PropTypes.String,
  href: PropTypes.String,
});
